import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { domAnimation, LazyMotion, m } from 'motion/react';
import { useMemo } from 'react';
import { Elevator } from '../../index.js';
export const PopoverContent = ({ showArrow = false, arrowColor = 'var(--dimmed-2)', offset = 4, children, usePortal = true, side, ...otherProps }) => {
    const computeOrigin = useMemo(() => {
        if (side === 'left') {
            return { x: 8, y: 0 };
        }
        if (side === 'right') {
            return { x: -8, y: 0 };
        }
        if (side === 'top') {
            return { x: 0, y: 8 };
        }
        return { x: 0, y: -8 };
    }, [side]);
    const animation = useMemo(() => ({
        hidden: {
            ...computeOrigin,
        },
        visible: {
            y: 0,
            x: 0,
        },
    }), [computeOrigin]);
    const renderContent = useMemo(() => (_jsx(PopoverPrimitive.Content, { asChild: true, sideOffset: Number(offset), side: side, style: { zIndex: 'var(--overlay-z-index)' }, ...otherProps, children: _jsxs(m.div, { initial: "hidden", animate: "visible", exit: "hidden", variants: animation, transition: {
                type: 'spring',
                stiffness: 700,
                damping: 30,
            }, children: [_jsx(Elevator, { resting: 2, children: children }), showArrow && _jsx(PopoverPrimitive.Arrow, { fill: arrowColor })] }) })), [animation, arrowColor, children, offset, otherProps, showArrow, side]);
    return (_jsx(LazyMotion, { features: domAnimation, strict: true, children: usePortal ? _jsx(PopoverPrimitive.Portal, { children: renderContent }) : renderContent }));
};
